export const allowed_stores = [2,5,6,7,10,11,12,14,16,20,21,22,23,24,25,26,72,1,70,71,69,65,82,79,60,27,74];
export const apply_store_list = [2,5,6,7,10,11,12,14,16,20,21,22,23,24,25,26,60,72,71,203,202,204,27,74];
export const storeNames = {
    1: 'מרכז הרשת',
    2: 'הרצליה',
    5: 'גבעתיים',
    6: 'נתניה',
    7: 'רעננה רננים',
    10: 'ממילא',
    11: 'מודיעין',
    12: 'רחובות',
    14: 'חיפה',
    16: 'פתח תקווה',
    20: 'לימיטד דיזנגוף',
    21: 'אשדוד',
    22: 'זכרון יעקב',
    23: 'גינדי',
    24: 'איילון',
    25: 'קניון הזהב',
    26: 'רמת אביב',
    60: 'אילת',
    71: 'עודפים תל גיבורים',
    72: 'חוצות המפרץ',
    202 :'plan B',
    203 : 'Plan B קניון הזהב',
    204 : 'plan B גבעתיים',
    27:'כפר סבא',
    74:'חנות 74'};